var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BImg, BButton, ModalPlugin, BAlert, VBTooltip, BCard } from 'bootstrap-vue';
import round from 'lodash/round';
import debounce from 'lodash/debounce';
import axios from '../../ts/modules/axios';
import { MountVisualisation, UnitSelector, SizeInput, MountboardSelector, MountOrderBreakdown, DiscountsBreakdown } from 'vallatonvue';
import LJLogo from '@/img/larson-juhl-logo.jpg';
import { addToCart, getMountItem } from '../../ts/modules/cart';
import { checkMountStock } from '../../ts/modules/stock';
Vue.use(ModalPlugin);
;
var BespokeMount = /** @class */ (function (_super) {
    __extends(BespokeMount, _super);
    function BespokeMount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingPrice = true;
        _this.loadingDiscounts = true;
        _this.addingToCart = false;
        _this.unit = 'mm';
        _this.externalSize = { width: 203, length: 254 };
        _this.apertureSize = { width: 146, length: 197 };
        _this.mountboard = null;
        _this.ljLogo = LJLogo;
        _this.ljLogoWebp = LJLogo.replace('.jpg', '.webp');
        _this.incUndermount = false;
        _this.quantity = 1;
        _this.mountPricing = {
            base_unit_price: '0.00',
            ex_vat_base_unit_price: '0.00',
            unit_price: '0.00',
            total_price: '0.00',
            unit_discount: '0.00',
            total_discount: '0.00'
        };
        _this.withUndermountPricing = {
            base_unit_price: '0.00',
            ex_vat_base_unit_price: '0.00',
            unit_price: '0.00',
            total_price: '0.00',
            unit_discount: '0.00',
            total_discount: '0.00'
        };
        _this.mountPrice = "0.00";
        _this.validationStrings = [];
        _this.warningStrings = [];
        _this.inStock = false;
        _this.discounts = [];
        _this.debouncedOnPriceChange = debounce(_this.onPriceChange, 250);
        _this.debouncedUpdatePrice = debounce(_this.updatePrice, 250);
        _this.debouncedCheckStock = debounce(_this.checkStock, 250);
        return _this;
    }
    Object.defineProperty(BespokeMount.prototype, "isValid", {
        get: function () {
            return this.validationStrings.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BespokeMount.prototype, "isAddToCartDisabled", {
        get: function () {
            return (this.validationStrings.length > 0 || this.loading || this.addingToCart);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BespokeMount.prototype, "cartButtonState", {
        get: function () {
            if (this.mountboard == null) {
                return 'secondary';
            }
            if (this.validationStrings.length > 0) {
                return 'danger';
            }
            if (this.warnings.length > 0) {
                return 'warning';
            }
            return 'success';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BespokeMount.prototype, "totalPrice", {
        get: function () {
            return this.incUndermount ? this.withUndermountPricing.total_price : this.mountPricing.total_price;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BespokeMount.prototype, "undermountPrice", {
        get: function () {
            return (parseFloat(this.withUndermountPricing.unit_price.replace(/,/g, '')) - parseFloat(this.mountPricing.unit_price.replace(/,/g, ''))).toFixed(2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BespokeMount.prototype, "sku", {
        get: function () {
            return "MCTS-".concat(this.mountboard ? this.mountboard.stock_lookup_sku : '8001');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BespokeMount.prototype, "baseUnitPrice", {
        get: function () {
            return this.incUndermount ? this.withUndermountPricing.base_unit_price : this.mountPricing.base_unit_price;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BespokeMount.prototype, "borderSizes", {
        get: function () {
            var width = (this.externalSize.width - this.apertureSize.width) / 2;
            var length = (this.externalSize.length - this.apertureSize.length) / 2;
            if (this.apertureSize.width == 0) {
                width = 0;
            }
            if (this.apertureSize.length == 0) {
                length = 0;
            }
            return {
                width: round(width, 1),
                length: round(length, 1)
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BespokeMount.prototype, "validate", {
        get: function () {
            var validations = {
                external: null,
                aperture: null,
                borders: null
            };
            this.validationStrings = [];
            if ((this.externalSize.width < this.apertureSize.width) ||
                (this.externalSize.length < this.apertureSize.length)) {
                this.validationStrings.push('Your aperture is larger than your external size on one or both dimensions.');
                validations.external = false;
                validations.aperture = false;
            }
            if ((this.externalSize.width == this.apertureSize.width) ||
                (this.externalSize.length == this.apertureSize.length)) {
                this.validationStrings.push('You aperture is equal to your external size on one or both dimensions.');
                validations.external = false;
                validations.aperture = false;
            }
            if ((this.apertureSize.width < 10 && this.apertureSize.width > 0) ||
                (this.apertureSize.length < 10 && this.apertureSize.length > 0)) {
                this.validationStrings.push('We have a minimum aperture size of 10mm to ensure that the mount can be cut correctly.');
                validations.aperture = false;
            }
            if (((this.borderSizes.width < 10 || this.borderSizes.length < 10) &&
                (this.borderSizes.width > 0 && this.borderSizes.length > 0)) ||
                ((this.borderSizes.width == 0 && this.borderSizes.length != 0) ||
                    (this.borderSizes.length == 0 && this.borderSizes.width != 0))) {
                this.validationStrings.push('We have a minimum border width of 10mm to ensure that the mount can be cut correctly.');
                validations.borders = false;
            }
            if (this.mountboard &&
                (( // long side of mount is longer than long side of board
                Math.max(this.externalSize.width, this.externalSize.length) >
                    Math.max(this.mountboard.sheet_width, this.mountboard.sheet_height)) ||
                    ( // short side of mount is longer than short side of board
                    Math.min(this.externalSize.width, this.externalSize.length) >
                        Math.min(this.mountboard.sheet_width, this.mountboard.sheet_height)))) {
                this.validationStrings.push('Your mount is larger than the maximum size we can supply in one piece.  Please call (<a href="tel:01246554338">01246 554338<a>) or e-mail (<a href="mailto:sales@epicturemounts.co.uk">sales@epicturemounts.co.uk</a>) us to discuss possible solutions.');
                validations.external = false;
            }
            if (Math.min(this.externalSize.width, this.externalSize.length) < 50) {
                this.validationStrings.push("We have a minimum dimension of 50mm to ensure that the mount can be cut correctly.");
                validations.external = false;
            }
            if (!this.inStock) {
                this.validationStrings.push("Unfortunately there is not enough stock of your chosen mountboard colour to fulfill your order.");
            }
            return validations;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BespokeMount.prototype, "warnings", {
        get: function () {
            var warningStrings = [];
            if ((this.borderSizes.width == 0 || this.borderSizes.length == 0) &&
                !((this.externalSize.width == this.apertureSize.width) ||
                    (this.externalSize.length == this.apertureSize.length))) {
                warningStrings.push('You have entered an aperture size of 0 for width and/or length.  This will result in a mount with no aperture (opening) cut - a solid board, essentially an undermount in the chosen colour.');
                return warningStrings;
            }
            if (Math.max(this.borderSizes.width, this.borderSizes.length) >
                (Math.min(this.borderSizes.width, this.borderSizes.length) * 2)) {
                warningStrings.push('One of your border widths is much greater or smaller than the other - please check the preview image to make sure you have entered your dimensions correctly.');
            }
            return warningStrings;
        },
        enumerable: false,
        configurable: true
    });
    BespokeMount.prototype.checkStock = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, checkMountStock('MCTS-' + (this.mountboard ? this.mountboard.stock_lookup_sku : '8001'), this.externalSize, this.quantity || 1)];
                    case 1:
                        _a.inStock = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BespokeMount.prototype.onPriceChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var discounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingDiscounts = true;
                        return [4 /*yield*/, axios.get('pricing/discounts/discountPrices', {
                                params: {
                                    prefix: 'MCTS',
                                    price: this.incUndermount ? this.withUndermountPricing.ex_vat_base_unit_price.replace(/,/g, '') : this.mountPricing.ex_vat_base_unit_price.replace(/,/g, '')
                                }
                            })];
                    case 1:
                        discounts = (_a.sent()).data;
                        this.discounts = discounts.map(function (discount) {
                            discount.discount = round(discount.discount * 100, 2);
                            return discount;
                        });
                        this.loadingDiscounts = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    BespokeMount.prototype.onLoadOfMountboards = function () {
        this.mountboard = this.mountboards.featured[0];
    };
    BespokeMount.prototype.onParametersChange = function () {
        this.debouncedUpdatePrice();
        this.debouncedCheckStock();
    };
    BespokeMount.prototype.pricingPayload = function (hasUndermount) {
        if (hasUndermount === void 0) { hasUndermount = false; }
        return {
            params: {
                sku: this.sku,
                width: this.externalSize.width,
                length: this.externalSize.length,
                quantity: this.quantity || 1,
                hasUndermount: hasUndermount ? 1 : 0,
                isMuseum: this.type == 'museum' ? 1 : 0
            }
        };
    };
    BespokeMount.prototype.updatePrice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var mountPricing, withUndermountPricing;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingPrice = true;
                        return [4 /*yield*/, axios.get('pricing/mountboard/cutToSize', this.pricingPayload())];
                    case 1:
                        mountPricing = (_a.sent()).data;
                        this.mountPricing = mountPricing;
                        return [4 /*yield*/, axios.get('pricing/mountboard/cutToSize', this.pricingPayload(true))];
                    case 2:
                        withUndermountPricing = (_a.sent()).data;
                        this.withUndermountPricing = withUndermountPricing;
                        this.loadingPrice = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    BespokeMount.prototype.addToCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var item, res, checkout, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.addingToCart = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        item = getMountItem(this.mountboard, this.externalSize, this.apertureSize, this.incUndermount, this.quantity, this.type == 'museum');
                        return [4 /*yield*/, addToCart(item)];
                    case 2:
                        res = _a.sent();
                        if (!res) return [3 /*break*/, 4];
                        // Log the gtag event
                        this.$gtm.trackEvent({
                            event: 'add_to_cart',
                            ecommerce: {
                                currency: 'GBP',
                                value: parseFloat(this.totalPrice),
                                items: [
                                    {
                                        item_id: item.sku,
                                        item_name: "".concat(this.mountboard.name, " Mountboard Cut to Size"),
                                        item_category: this.type == 'museum' ? "Museum Grade" : "Whitecore/Conservation Grade",
                                        quantity: item.qty,
                                        price: parseFloat(this.totalPrice),
                                        currency: 'GBP'
                                    }
                                ]
                            }
                        });
                        this.$bus.emit('cart-change');
                        return [4 /*yield*/, this.$bvModal.msgBoxConfirm("Successfully added item to the cart!", {
                                okTitle: 'Checkout',
                                cancelTitle: 'Continue Shopping'
                            })];
                    case 3:
                        checkout = _a.sent();
                        if (checkout) {
                            this.$router.push({ "name": 'cart' });
                        }
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        return [3 /*break*/, 6];
                    case 6:
                        this.addingToCart = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    BespokeMount.prototype.created = function () {
        this.mountboard = this.mountboards.featured[0];
        this.$bus.on('vat-change', this.updatePrice);
    };
    __decorate([
        Prop({ type: Object, required: true })
    ], BespokeMount.prototype, "mountboards", void 0);
    __decorate([
        Prop({ type: Boolean, default: true })
    ], BespokeMount.prototype, "loading", void 0);
    __decorate([
        Prop({ type: String })
    ], BespokeMount.prototype, "type", void 0);
    __decorate([
        Watch('baseUnitPrice')
    ], BespokeMount.prototype, "debouncedOnPriceChange", void 0);
    __decorate([
        Watch('mountboards', { deep: true })
    ], BespokeMount.prototype, "onLoadOfMountboards", null);
    __decorate([
        Watch('externalSize', { deep: true }),
        Watch('mountboard', { deep: true }),
        Watch('quantity')
    ], BespokeMount.prototype, "onParametersChange", null);
    BespokeMount = __decorate([
        Component({
            components: {
                BRow: BRow,
                BCol: BCol,
                BFormGroup: BFormGroup,
                BFormInput: BFormInput,
                BFormCheckbox: BFormCheckbox,
                BImg: BImg,
                BButton: BButton,
                BAlert: BAlert,
                BCard: BCard,
                MountVisualisation: MountVisualisation,
                UnitSelector: UnitSelector,
                SizeInput: SizeInput,
                MountboardSelector: MountboardSelector,
                MountOrderBreakdown: MountOrderBreakdown,
                DiscountsBreakdown: DiscountsBreakdown
            },
            directives: {
                "b-tooltip": VBTooltip
            }
        })
    ], BespokeMount);
    return BespokeMount;
}(Vue));
export default BespokeMount;
